import { type RcFile } from 'antd/es/upload'
import imageCompression from 'browser-image-compression'

export const getImageAspectRatio = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const img = new Image()
      img.onload = () => {
        const aspectRatio = img.width / img.height
        resolve(aspectRatio)
      }
      img.onerror = reject

      if (typeof reader.result === 'string') {
        img.src = reader.result
      } else {
        reject(new Error('Could not read image data'))
      }
    }

    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}

export async function getImageAverageColor(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)
    img.src = objectUrl
    img.crossOrigin = 'Anonymous'

    img.onload = () => {
      import('fast-average-color')
        .then(({ FastAverageColor }) => {
          const fac = new FastAverageColor()
          fac
            .getColorAsync(img)
            .then((color) => {
              resolve(color.hex.replace('#', ''))
              URL.revokeObjectURL(objectUrl)
            })
            .catch((err: string) => {
              URL.revokeObjectURL(objectUrl)
              reject(new Error('Get color error: ' + err))
            })
        })
        .catch((err: string) => {
          URL.revokeObjectURL(objectUrl)
          reject(new Error('Failed to load fast-average-color: ' + err))
        })
    }

    img.onerror = (event) => {
      URL.revokeObjectURL(objectUrl)
      const message = `Image load error: ${typeof event === 'string' ? event : event.type}`
      reject(new Error(message))
    }

    img.src = objectUrl
  })
}

export async function getCompressedImage(file: RcFile): Promise<RcFile> {
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 800,
    useWebWorker: true,
  }

  try {
    const compressedFile = await imageCompression(file, options)

    const newRcFile = new File([compressedFile], file.name, {
      type: compressedFile.type,
      lastModified: file.lastModified,
    }) as RcFile

    newRcFile.uid = file.uid

    return newRcFile
  } catch (error) {
    console.error(error)
    throw error
  }
}
